export const POLICY_NAMES = {
  authorizationForUseAndDisclosure: 'Collective Bargaining Agreement',
  legalInformationAndPrivacyPolicy: 'Legal Information and Privacy Policy',
  timeAndAttendance: 'Time and Attendance Policy',
  grievancePolicy: 'Grievance Policy',
  salaryatsea: 'Salary@Sea Policy',
  wellnesspolicy: 'Wellness Statement',
  debarkWellnessStatement: 'Debark Wellness Statement',
  debarkHealthStatement: 'Debark Health Statement',
  debarkDoctorsInjuryStatement: 'Debark Health Statement',
  noShowPolicy: 'No Show Policy',
  travelChangesAcknowledgement: 'Travel Changes Acknowledgement',
};
